export const PROFILE_IMAGE_SIZE = 95;
